import { ActionTypes } from './Actions/types'

/**
 * Это строки для иконок material-icons,
 * необходимо обернуть в тэг <i class="material-icons"> {{ тут функция с передачей типа экшена }} </i>
 * */
export const getActionNodeActionsIcons = (type: ActionTypes): string => {
  switch (type) {
    case ActionTypes.AddLabel:
      return 'new_label'
    case ActionTypes.RemoveLabel:
      return 'label_off'
    case ActionTypes.NotifyGroup:
      return 'notifications'
    case ActionTypes.NotifyUsers:
      return 'notifications'
    case ActionTypes.Property:
      return 'edit_note'
    case ActionTypes.RemoveProperties:
      return 'delete_sweep'
    case ActionTypes.CreateInviteLink:
      return 'link'
    case ActionTypes.JoinRequest:
      return 'front_hand'
    case ActionTypes.Kick:
      return 'person_off'
    case ActionTypes.DeleteLastMessageAction:
      return 'do_not_disturb_alt'
    case ActionTypes.Ban:
      return 'cancel'
    case ActionTypes.Publish:
      return 'calendar_today'
  }
}
